
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimesCircle, faEnvelope, faSave, faExclamationCircle, faClone, faCheck, faPaperPlane, faArrowLeft, faRotateLeft, faDownload } from '@fortawesome/free-solid-svg-icons'
import { parseISO, format, addMinutes } from 'date-fns'
import api from '@/services/api'
import tecnoPayAPI from '@/services/tecnopay-api'
import utils from '@/utils'

import { PrimaryButton, Button } from '@design-system/ui'
import CustomInput from '../components/input/Input.vue'

import Toast from '../components/Toast.vue'
import Tooltip from '../components/Tooltip.vue'

export default {
  name: 'SoftwareHouseDetails',
  components: {
    FontAwesomeIcon,
    Toast,
    PrimaryButton,
    Button,
    Tooltip,
    CustomInput
  },
  props: ['softwareHouseCnpj', 'data', 'mediatorFee', 'validateByPass', 'isEdit', 'isFinished', 'alreadyRegistered'],
  data () {
    return {
      responsible: {
        fullName: '',
        cpf: '',
        cellPhone: '',
        email: '',
        status: '',
        role: ''
      },
      technicalResponsible: {
        fullName: '',
        cpf: '',
        cellPhone: '',
        email: '',
        status: '',
        role: ''
      },
      buttonIcons: {
        cancel: {
          icon: faTimesCircle
        },
        email: {
          icon: faEnvelope
        },
        sendEmail: {
          icon: faPaperPlane
        },
        save: {
          icon: faSave,
          inconCustomClass: 'filter brightness-0 invert flex items-end'
        },
        copy: {
          icon: faClone
        },
        done: {
          icon: faCheck
        },
        return: {
          icon: faArrowLeft
        },
        undo: {
          icon: faRotateLeft
        },
        download: {
          icon: faDownload
        }
      },
      linkHasCopied: false,
      alert: faExclamationCircle,
      invalidSoftwareHouse: false,
      invalidRepresentante: false,
      invalidResponsavel: false,
      invalidResponsavelTecnico: false,
      buttonNewMediatorFee: false,
      toastSuccess: true,
      recoveryProtocolModal: false,
      downloadInProgress: false,
      formValidation: {
        inputMediatorFee: ''
      },
      inputMediatorFee: null,
      onboadingLink: '',
      regimes: {
        lucro_real: 'Lucro Real',
        lucro_presumido: 'Lucro Presumido',
        simples_nacional: 'Simples Nacional',
        mei: 'MEI'
      },
      formats: [
        { value: 'sociedade_anonima', label: 'Sociedade Anônima' },
        { value: 'sociedade_simples', label: 'Sociedade Simples' },
        { value: 'sociedade_empresaria_limitada', label: 'Sociedade Empresária Limitada' },
        { value: 'microempreendedor_individual', label: 'Microempreendedor Individual' },
        { value: 'empresa_individual_de_responsabilidade_limitada', label: 'Empresa Individual de Responsabilidade Limitada' },
        { value: 'empresa_individual', label: 'Empresa Individual' },
        { value: 'sociedade_limitada_unipessoal', label: 'Sociedade Limitada Unipessoal' }
      ],
      empty: 'Valor ainda não informado no cadastro',
      message: '',
      hidden: true,
      timeSeen: 20000,
      actualMediatorFee: null
    }
  },
  created () {
    if (this.isEdit && !this.isFinished) {
      this.onboardingLink = utils.checkUrl()
      this.generateHash(this.data.preRegister.uuid)
    }
    this.actualMediatorFee = this.mediatorFee
    this.responsible = this.data.responsibles?.find((responsible) => responsible.role === 'responsavel')
    this.technicalResponsible = this.data.responsibles?.find((responsible) => responsible.role === 'tecnico')
  },
  watch: {
    data () {
      this.responsible = this.data.responsibles?.find((responsible) => responsible.role === 'responsavel')
      this.technicalResponsible = this.data.responsibles?.find((responsible) => responsible.role === 'tecnico')
    }
  },
  methods: {
    applyDateFormat (data: string): string {
      const date = parseISO(data)
      const adjustedDate = addMinutes(date, date.getTimezoneOffset())
      return format(adjustedDate, 'dd/MM/yyyy')
    },
    isValid (info: string, section: string): boolean {
      if (!this.validateByPass && this.validation) {
        let response = true
        response = this.validation.emails.some((email) => email.email === info && email.validated === true)
        if (!response) {
          response = this.validation.telefones.some((telefone) => telefone.phone === info && telefone.validated === true)
        }
        if (!response) {
          this.invalidRepresentante = section === 'representante' ? true : this.invalidRepresentante
          this.invalidResponsavel = section === 'responsavel' ? true : this.invalidResponsavel
          this.invalidResponsavelTecnico = section === 'tecnico' ? true : this.invalidResponsavelTecnico
          this.invalidSoftwareHouse = section === 'software-house' ? true : this.invalidSoftwareHouse
        }
        return response
      }

      return true
    },
    changeField (_index: string, value: string): void {
      if (value) this.inputMediatorFee = parseFloat(value.replaceAll('.', '').replaceAll(',', '.').replaceAll('R$ ', ''))

      if (this.inputMediatorFee.toString().replaceAll('.', '').length > 10) {
        this.formValidation.inputMediatorFee = 'A tarifa padrão deve ter no máximo 8 dígitos a esquerda e 2 a direita.'
        this.buttonNewMediatorFee = false
        return
      }

      if (this.inputMediatorFee <= 0) {
        this.formValidation.inputMediatorFee = 'A tarifa padrão deve ser maior que zero.'
        this.buttonNewMediatorFee = false
        return
      }

      this.formValidation.inputMediatorFee = ''
      if (this.inputMediatorFee !== Number(this.actualMediatorFee)) {
        this.buttonNewMediatorFee = true
      } else {
        this.buttonNewMediatorFee = false
      }
    },
    hide () {
      this.hidden = true
    },
    recovery () {
      this.loading = true

      tecnoPayAPI.get('/software-houses/recuperacao/' + this.softwareHouseCnpj.replaceAll('/', '').replaceAll('.', '').replaceAll('-', '')).then(response => {
        this.recoveryProtocolModal = false
        this.hidden = false
        this.toastSuccess = true
        this.message = 'E-mail enviado.'
        setTimeout(() => {
          this.hidden = true
        }, 20000)
      }).catch(() => {
        this.hidden = false
        this.toastSuccess = false
        this.message = 'Ocorreu um erro ao enviar o e-mail.'
        setTimeout(() => {
          this.hidden = true
        }, 20000)
      })
      this.loading = false
    },
    editMediatorFee () {
      api.patch(`/software-houses/${this.softwareHouseCnpj.replace(/\D/g, '')}`, {
        mediatorFee: this.inputMediatorFee
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).then(() => {
        this.actualMediatorFee = this.inputMediatorFee
        this.buttonNewMediatorFee = false
        this.hidden = false
        this.toastSuccess = true
        this.message = 'Tarifa alterada'
        setTimeout(() => {
          this.hidden = true
        }, this.timeSeen)
      })
        .catch((error) => {
          this.hidden = false
          this.toastSuccess = false
          this.message = error.response && error.response.data && error.response.data.error_messages[0] ? error.response.data.error_messages[0] : 'Ocorreu um erro ao alterar a tarifa'
          setTimeout(() => {
            this.hidden = true
          }, this.timeSeen)
        })
    },
    async downloadContract () {
      try {
        this.downloadInProgress = true
        const response = await api.get(`/contracts/software-house/${this.softwareHouseCnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        this.downloadInProgress = false
        const contractBuffer = response.data.contract
        const byteArray = new Uint8Array(contractBuffer)
        const blob = new Blob([byteArray], { type: 'application/octet-stream' })
        utils.openLinkToDownloadFile(blob, 'contrato-de-adesao.pdf')
      } catch (error) {
        this.downloadInProgress = false
        this.hidden = false
        this.toastSuccess = false
        this.message = error.response && error.response.data && error.response.data.error_messages[0] ? error.response.data.error_messages[0] : 'Ocorreu um erro ao baixar o arquivo'
        setTimeout(() => {
          this.hidden = true
        }, this.timeSeen)
      }
    },
    generateHash (uuid: string) {
      this.onboardingLink += `/softwarehouse/${uuid}`
    },
    handleCopy () {
      this.linkHasCopied = true
      setTimeout(() => {
        this.linkHasCopied = false
      }, 3000)
      navigator.clipboard.writeText(this.onboardingLink)
    },
    applyMask: utils.applyMask
  }
}
